import React from 'react';

import { OrderPageStore } from 'app/logic/pages/order/OrderPageStore';
import { Section } from 'app/component/Section';
import { AddressForm } from 'app/logic/address/AddressForm';
import { OrderFormValues } from 'app/logic/pages/order/OrderPage';

export interface RegistrationAddressFormSectionProps {
    pageStore: OrderPageStore;
}

export const RegistrationAddressFormSection = ({
    pageStore,
}: RegistrationAddressFormSectionProps) => {
    return (
        <Section
            className={'registrationAddressFormSection'}
            title={'Адрес регистрации'}
            content={
                <AddressForm<OrderFormValues, unknown>
                    className={'registration'}
                    prefix={'registrationAddress'}
                    formStore={pageStore.orderFormStore.registrationAddress}
                />
            }
        />
    );
};
